export class UploadMimeType {
  public static readonly ALL = '*'
  public static readonly IMAGE = 'image/*'
}
